import type { AgendaEvent } from '@amumin/api-client';
import { EventCard, type EventCardLabels } from '@amumin/ui-core';

import {
  driverOf,
  isEveryone,
  membersOf,
  splitDriversText,
  toCardMember,
  type MemberLite,
} from '../lib/agenda.js';
import { ridesInAgenda } from '../state/modules.js';
import { messages } from '../state/session.js';

export function eventCardLabels(): EventCardLabels {
  return messages.value.design.eventCard;
}

/**
 * Eén afspraak als rustige kaart (ui-core EventCard): kleurstreep per lid, pictogram, tijd,
 * gezichtjes, rijder of "Wie rijdt?", en herhaald/verplaatst/gewijzigd/afgelast.
 */
export function EventItem({
  ev,
  members,
  onOpen,
  tone,
}: {
  ev: AgendaEvent;
  members: ReadonlyArray<MemberLite>;
  onOpen: (ev: AgendaEvent) => void;
  tone?: 'default' | 'next' | 'past';
}) {
  const who = isEveryone(ev.member_ids, members)
    ? membersOf('everyone', members)
    : membersOf(ev.member_ids, members);
  const end = ev.end_hhmm === '24:00' ? null : ev.end_hhmm;
  // 0029: "Brengen en halen in de agenda tonen" uit = geen ritregel (het blad toont hem wel).
  const rides = ridesInAgenda();
  return (
    <EventCard
      name="event-row"
      title={ev.title}
      time={ev.continues_from_previous ? '00:00' : ev.start_hhmm}
      endTime={end}
      allDay={ev.all_day}
      icon={ev.icon}
      // Restpunten: geen pictogram per regel in de ouderapp (volwassen context).
      showIcon={false}
      members={who.map(toCardMember)}
      householdSize={members.length}
      location={ev.location}
      driver={rides ? driverOf(ev, members) : null}
      driverText={
        rides ? splitDriversText(ev, members, messages.value.design.eventCard.splitDrives) : null
      }
      repeat={ev.recurring}
      moved={ev.moved}
      changed={ev.modified && !ev.moved}
      cancelled={ev.cancelled}
      tone={tone ?? 'default'}
      labels={eventCardLabels()}
      onPress={() => onOpen(ev)}
    />
  );
}
